module.exports = __webpack_public_path__ + "static/media/pvoHero_small.a906f39e.jpg";